import "core-js/modules/es.array.push.js";
import api from "assets/js/public.js";
export default {
  data() {
    return {
      page: 1,
      list: [],
      nav: 1
    };
  },
  methods: {
    getList() {
      // @ts-ignore
      api.postion({
        status: 0,
        type: this.nav,
        pageNum: this.page,
        pageSize: 5
      }).then(res => {
        this.list = res.data.list;
      });
    },
    changeTab(type) {
      this.nav = type;
      this.getList();
    },
    goDetail(item) {
      this.$router.push({
        path: "/positionDetail",
        query: {
          id: item.unid
        }
      });
    }
  },
  created() {
    this.getList();
  }
};